const esJSON = {
  LOGO: {
    VERSION: '1.0',
    VERSION_DESC: 'Primera versión',
    SYSTEM_NAME: 'Sokodev'
  },
  DASHBOARD: {
    HEADING: 'Principal',
    SUBHEADING: 'Resumen de datos del panel de administrador'
  },
  MY_ACCOUNT: {
    HEADING: "Mi cuenta",
    SUBHEADING: "Información general y configuración de la cuenta",
    USER_DETAILS: "Detalles del usuario",
    USER_DETAILS_DESCRIPTION: "Administra la información de usuario",
    BTN_CHANGE_PASSWORD: "Cambiar contraseña",
    BTN_EDIT: "Editar",
    ACCOUNT_EDIT: "Editar perfil",
    ACCOUNT_EDIT_DESCRIPTION: "Formulario de edición del perfil",
    PROFILE_INFO_UPDATED: "Se ha actualizado la información del perfil",
    PROFILE_INFO_UPDATED_WITH_ERROR: "Se ha actualizado la información del perfil, pero, ocurrió un error al mostrar los datos actualizados.",
    CHANGE_PASSWORD_HEADING: "Cambiar contraseña",
    CHANGE_PASSWORD_SUBHEADING: "Formulario para cambiar la contraseña",
    PASSWORD_UPDATED: "Se ha actualizado la contraseña"
  },
  LOGIN: {
    HEADING: "Iniciar sesión",
    SUBHEADING: "Rellena los campos a continuación para iniciar sesión",
    REGISTER: "Registrarse",
    DONT_YOU_HAVE_AN_ACCOUNT: "¿No tienes una cuenta?",
    LOST_PASSWORD: "¿Olvidaste tu contraseña?"
  },
  REGISTER: {
    HEADING: "Registrar cuenta",
    SUBHEADING: "Completa los campos a continuación para crear una cuenta nueva.",
    BACK_TO: "Regresar a",
    USER_REGISTERED: "Se ha registrado el usuario"
  },
  LANGUAGE_SWITCHER: {
    HEADING: "Lenguage",
    SUBHEADING: "Cambia el lenguaje"
  },
  RECOVER_PASSWORD: {
    HEADING: "Recuperar contraseña",
    SUBHEADING: "Introduce tu correo electrónico para reiniciar tu contraseña",
    BACK_TO_LOGIN: "Quieres volver a iniciar sesión?",
    INSTRUCTIONS: "Las instrucciones para recuperar tu contraseña se han enviado a tu correo electrónico.",
    CHECK_MAIL: "Revisa tu correo electrónico para recuperar tu contraseña",
    TO_LOGIN: "Ir a iniciar sesión"
  },
  ROLES: {
    HEADING: "Roles",
    SUBHEADING: "Administración de los roles y permisos",
    CREATE: "Crear rol",
    CREATE_DESC: "Completa el formulario para crear un rol",
    EDIT: "Editar rol",
    EDIT_DESC: "Completa el formulario para editar el rol",
    SHOW: "Detalles del rol",
    SHOW_DESC: "Información completa del rol seleccionado",
    DELETE: "Borrar rol",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el rol seleccionado?",
    DELETED: "Se ha borrado el rol seleccionado",
    SEARCH: "Buscar por nombre o descripción",
    PERMISSIONS: "Permisos",
    SAVED: "Se ha guardado el rol.",
    EDITED: "Se ha editado el rol."
  },
  USERS: {
    HEADING: "Usuarios",
    SUBHEADING: "Administración de los usuarios",
    CREATE: "Crear usuario",
    CREATE_DESC: "Completa el formulario para crear un usuario",
    EDIT: "Editar usuario",
    EDIT_DESC: "Completa el formulario para editar el usuario",
    SHOW: "Detalles del usuario",
    SHOW_DESC: "Información completa del usuario seleccionado",
    DELETE: "Borrar usuario",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el usuario seleccionado?",
    DELETED: "Se ha borrado el usuario seleccionado",
    SEARCH: "Buscar por nombre de usuario o correo electrónico",
    ACTIVE: {
      0: 'Desctivado',
      1: 'Activado'
    }
  },
  RESET_PASSWORD: {
    HEADING: "Reiniciar contraseña",
    SUBHEADING: "Llena los campos para reiniciar tu contraseña",
    INSTRUCTIONS: "Ahora puedes iniciar sesión con tu nueva contraseña",
    SUCCESS: "Se ha reiniciado la contraseña",
    TO_LOGIN: "Ir a iniciar sesión"
  },
  EMAIL_VERIFICATION: {
    HEADING: "Verificación de correo",
    SUBHEADING: "Es necesario verificar tu correo electrónico para el uso del sistema. \n Al momento de registrarte se ha enviado un correo de verificación, en caso de no haberlo recibido puedes solicitar otro pulsando el siguiente botón.",
    BUTTON: "Solicitar un correo de verificación",
    SUCCESS: "Se ha enviado el correo de verificación a la dirección registrada"
  },
  VERIFY_EMAIL: {
    HEADING: "Verificación de correo",
    SUBHEADING: "Es necesario que el correo electrónico sea verificado para hacer uso del sistema",
    VERIFYING: "Verificando correo electrónico",
    VERIFIED: "Se ha verificado el correo electrónico con éxito, serás redirigido al inicio",
    VERIFIED_ERROR: "Hubo un error verificando tu correó electrónico, puedes solicitar un nuevo correó de verificacón en el siguiente botón",
    VERIFY: "Verificar correo electrónico",
    BUTTON: "Ir a solicitar un correo de verificación"
  },
  THEME_SETTINGS: {
    CHOOSE_LAYOUT: "Selecciona la distribución",
    CHOOSE_THEME: "Selecciona el tema",
    ADMIN_PANEL_LAYOUT: "Distribución del panel de administrador",
    ADMIN_PANEL_LAYOUT_DESCRIPTION: "Cambia el acomodo de la información",
    ADMIN_PANEL_THEME: "Tema del panel de administrador",
    ADMIN_PANEL_THEME_DESCRIPTION: "Cambia los colores",
    THEMES: {
      PURE_LIGHT_THEME: "Pure Light",
      GRAY_GOOSE_THEME: "Gray Goose",
      PURPLE_FLOW_THEME: "Purple Flow"
    },
    LAYOUTS: {
      EXTENDED_SIDEBAR: "Extended Sidebar",
      ACCENT_HEADER: "Accent Header",
      ACCENT_SIDEBAR: "Accent Sidebar",
      BOXED_SIDEBAR: "Boxed Sidebar",
      COLLAPSED_SIDEBAR: "Collapsed Sidebar",
      BOTTOM_NAVIGATION: "Bottom Navigation",
      TOP_NAVIGATION: "Top Navigation"
    },
  },
  FIELDS: {
    NAME: "Nombre",
    EMAIL: "Correo electrónico",
    LASTNAME: "Apellido",
    CURRENT_PASSWORD: "Contrseña actual",
    PASSWORD: "Contraseña",
    PASSWORD_CONFIRMATION: "Confirmación de contraseña",
    REMEMBER: "Recuerdame",
    DESCRIPTION: "Descripción",
    ID: "Id",
    CREATED_AT: "Creado",
    UPDATED_AT: "Actualizado",
    ROLE: "Rol",
    ROLE_ID: "Rol",
    ACTIVE: "Estado",
    EMAIL_VERIFIED_AT: 'Verificado',
    RFC: 'RFC',
    POSTAL_CODE: 'Código postal',
    TAX_REGIME: 'Régimen fiscal',
    STREET: 'Calle',
    SUBURB: 'Colonia',
    CITY: 'Ciudad',
    STATE: 'Estado',
    COUNTRY: 'País',
    EXPEDITION_PLACE: 'Lugar de expedición',
    LOGO_TYPE: 'Tipo/Tamaño de logo',
    LOGO: 'Logo',
    CLIENT: 'Cliente',
    EXPEDITOR: 'Emisor',
    CLIENT_RFC: 'RFC (Cliente)',
    CLIENT_NAME: 'Nombre (Cliente)',
    EXPEDITOR_RFC: 'RFC (Emisor)',
    EXPEDITOR_NAME: 'Nombre (Emisor)',
    NOTE: 'Nota',
    FONT: 'Fuente',
    FONT_SIZE: 'Tamaño de fuente',
    FONT_SIZE_TITLE: 'Tamaño de fuente (título)',
    IDENTIFIER: 'Clave',
    COMBINE_ITEMS: 'Combinar artículos',
    CONF_VALUE_0: 'Clave',
    CONF_VALUE_1: 'Desc',
    CONF_VALUE_2: 'Ambos',
    CONF_CFDI_USES: 'Uso CFDI',
    CONF_OBJ_IMP: 'Objeto Impuesto',
    CONF_PAYMENT_METHODS: 'Forma de Pago',
    CONF_PAYMENT_TYPES: 'Método de Pago',
    CONF_PROD_SERV_KEYS: 'Clave de Producto o Servicio',
    CONF_TAX_REGIMES_EXPEDITOR: 'Régimen Fiscal Emisor',
    CONF_TAX_REGIMES_CLIENT: 'Régimen Fiscal Cliente/Receptor',
    CONF_TAX_TYPES: 'Impuesto (General)',
    CONF_TAX_TYPES_ITEMS: 'Impuesto (por Concepto)',
    CONF_UNIT_KEYS: 'Clave de Unidad',
  },
  VALIDATION: {
    REQUIRED: "El campo es requerido.",
    EMAIL: "El campo debe ser un correo electrónico válido.",
    MIN_ONE: "Es necesario seleccionar al menos 1."
  },
  GENERAL: {
    CANCEL: "Cancelar",
    LOGOUT: "Cerrar sesión",
    CLOSE: "Cerrar",
    NO_RESULTS: "No se han econtrado resultados",
    SEARCH: "Buscar",
    ACTIONS: "Acciones",
    GO_TO_HOMEPAGE: "Volver a inicio",
    BULK_ACTIONS: "Acciones masivas",
    BULK_DELETE: "Borrar seleccionados",
    SELECT_BETWEEN_VIEWS: "Selecciona la distribución para mostrar la lista entre una tabla y tarjetas.",
    RESET: 'Reiniciar formulario'
  },
  STATUS: {
    404: {
      MESSAGE: "La página que buscas no existe."
    },
    403: {
      MESSAGE: "No estás autorizado para realizar esta acción."
    },
    401: {
      MESSAGE: "No se ha iniciado sesión o la sesión ha caducado"
    }
  },
  CLIENTS: {
    HEADING: "Clientes",
    SUBHEADING: "Administración de los clientes",
    CREATE: "Crear cliente",
    CREATE_DESC: "Completa el formulario para crear un cliente",
    EDIT: "Editar cliente",
    EDIT_DESC: "Completa el formulario para editar el cliente",
    SHOW: "Detalles del cliente",
    SHOW_DESC: "Información completa del cliente seleccionado",
    DELETE: "Borrar cliente",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el cliente seleccionado?",
    DELETED: "Se ha borrado el cliente seleccionado",
    SEARCH: "Buscar por RFC o nombre",
    PERMISSIONS: "Permisos",
    SAVED: "Se ha guardado el cliente.",
    EDITED: "Se ha editado el cliente."
  },
  'INVOICE-EXPEDITORS': {
    HEADING: "Emisores",
    SUBHEADING: "Administración de los emisores",
    CREATE: "Crear emisor",
    CREATE_DESC: "Completa el formulario para crear un emisor",
    EDIT: "Editar emisor",
    EDIT_DESC: "Completa el formulario para editar el emisor",
    SHOW: "Detalles del emisor",
    SHOW_DESC: "Información completa del emisor seleccionado",
    DELETE: "Borrar emisor",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el emisor seleccionado?",
    DELETED: "Se ha borrado el emisor seleccionado",
    SEARCH: "Buscar por RFC o nombre",
    PERMISSIONS: "Permisos",
    SAVED: "Se ha guardado el emisor.",
    EDITED: "Se ha editado el emisor."
  },
  'INVOICE-CLIENT-CONFIGS': {
    HEADING: "Configucariones de cliente para facturación",
    SUBHEADING: "Administración de las configucariones de cliente para facturación",
    CREATE: "Crear configucariones de cliente para facturación",
    CREATE_DESC: "Completa el formulario para crear una configucariones de cliente para facturación",
    EDIT: "Editar configucariones de cliente para facturación",
    EDIT_DESC: "Completa el formulario para editar la configucariones de cliente para facturación",
    SHOW: "Detalles de la configucariones de cliente para facturación",
    SHOW_DESC: "Información completa de la configucariones de cliente para facturación seleccionada",
    DELETE: "Borrar configucariones de cliente para facturación",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar la configucarión de cliente para facturación seleccionado?",
    DELETED: "Se ha borrado la configucarión de cliente para facturación seleccionado",
    SEARCH: "Buscar por RFC o nombre",
    PERMISSIONS: "Permisos",
    SAVED: "Se ha guardado la configucariones de cliente para facturación.",
    EDITED: "Se ha editado la configucariones de cliente para facturación."
  },
  'INVOICE-COMBINE-KEYS': {
    HEADING: "Combinar productos",
    SUBHEADING: "Administración de los productos a combinar",
    CREATE: "Crear combinar producto",
    CREATE_DESC: "Completa el formulario para una clave del SAT a combinar",
    EDIT: "Editar combinar producto",
    EDIT_DESC: "Completa el formulario para editar combinar producto",
    SHOW: "Detalles de combinar producto",
    SHOW_DESC: "Información completa de combinar producto seleccionado",
    DELETE: "Borrar combinar producto",
    DELETE_CONFIRM_MESSAGE: "¿Realmente desea borrar el combinar producto seleccionado?",
    DELETED: "Se ha borrado el combinar producto seleccionado",
    SEARCH: "Buscar por RFC o nombre o clave del SAT",
    PERMISSIONS: "Permisos",
    SAVED: "Se ha guardado el combinar producto.",
    EDITED: "Se ha editado el combinar producto."
  },
  'INVOICER-XML-TO-PDF': {
    HEADING: "Generar PDF en base a un XML",
    SUBHEADING: "Configucariones para generar el PDF",
    CREATE: "Generar PDF",
  },
  'INVOICER-XML-TO-LIST': {
    HEADING: "Generar lista de productos en base a un XML del SAP",
    SUBHEADING: "Configucariones para generar la lista de productos",
    CREATE: "Generar lista",
  },
  'GENERIC-INVOICE-CATALOGS': {
    HEADING: "Catálogos del SAT",
    SUBHEADING: "Administración de los catálogos",
    SEARCH: "Buscar por Clave o descripción",
    CREATE: "Importar excel",
    CREATE_DESC: "Actualizar catálogo mediante un excel",
    UPDATE: "Actualizar datos",
  }
};

export default esJSON;
